// Порт ref SubBlockSettingsEditor:397-421 (renderBadgeVariantSelector) + :596-604
// (BadgeEditor). Раскладку (горизонт/вертикаль) реф уже не предлагает — бейджи
// всегда горизонтально, поэтому селектора раскладки тут нет.
import { cn, Label } from '@teach/ui'
import type { DesignBadge } from '@/types/blocks'
import { BADGE_VARIANT_OPTIONS, resolveBadgeVariant } from '@/features/editor/lib/badgeVariants'
import { badgeVariantStyle } from '@/features/editor/lib/badgeStyles'
import { BadgeList } from './BadgeList'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  element: DesignBadge
  onUpdate: (patch: Partial<DesignBadge>) => void
}

export const BadgeSettings = ({ element, onUpdate }: Props) => {
  // Легаси-«овал» подсвечиваем как «Объём» — тем же правилом, что и рендер.
  const active = resolveBadgeVariant(element.badgeVariant)
  const m = useMessages(messages)

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">{m.badgeStyle}</Label>
        <div className="grid grid-cols-3 gap-1">
          {BADGE_VARIANT_OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              onClick={() => onUpdate({ badgeVariant: value })}
              aria-label={label}
              aria-pressed={active === value}
              className={cn(
                'flex flex-col items-center gap-1.5 rounded-lg px-2 py-2.5 text-xs transition-colors',
                active === value
                  ? 'bg-foreground/10 ring-1 ring-primary'
                  : 'bg-muted hover:bg-muted/80',
              )}
            >
              {/* Сразу видно, как выглядит стиль: мини-бейдж в нём. */}
              <span
                className="rounded-full px-3 py-1 text-xs font-semibold"
                style={badgeVariantStyle(value)}
              >
                {m.badgeSample}
              </span>
              {label}
            </button>
          ))}
        </div>
      </div>

      <BadgeList badges={element.badges} onChange={(badges) => onUpdate({ badges })} />
    </div>
  )
}
